module.exports = __webpack_public_path__ + "static/media/portfolio.2b280d6d.png";